<template>
  <div
    class="poi-card-item"
    @click="goPoiDetail(item.poiId, item.poiName)"
  >
    <div class="title">
      {{ item.poiName }}
    </div>
    <div class="content">
      <div
        class="content-item"
        style="margin-top: 0.18rem;"
      >
        <div class="label">
          服务等级
        </div>
        <div class="service-level-value">
          <img
            v-if="typeof item.serviceGrade === 'number' && !isNaN(item.serviceGrade) && item.serviceGrade>0"
            :src="getServiceGradeImg(item.serviceGrade)"
          />
          <span
            v-else
            class="lower-rank"
          >
            暂无定级
          </span>
          <div
            v-if="item.bizareaRank<=20 && item.bizareaRank>0"
            class="higher-rank"
          >
            同商圈服务等级第{{ item.bizareaRank }}名·超过{{ item.bizareaRankRatio }}同行
          </div>
          <div
            v-if="typeof item.bizareaRank === 'number' && !isNaN(item.bizareaRank) && item.bizareaRank>20"
            class="lower-rank"
          >
            超过{{ item.bizareaRankRatio }}同行
          </div>
        </div>
      </div>
      <div
        class="content-item"
        style="border-bottom: 1px solid #EFEFEF;padding-bottom: 0.15rem;margin-top: 0.15rem;"
      >
        <div class="label">
          业务经理
        </div>
        <div class="maintainer-mis-value">
          <div>{{ item.maintainerName || '--' }}</div>
          <div
            v-if="item.maintainerName"
            class="phone-call"
            @click.stop="callPhone(item.poiId, item.maintainerMis)"
          >
            <img src="@/assets/img/phone@2x.png" />
            <div>拨打电话</div>
          </div>
        </div>
      </div>
      <div
        class="content-item"
        style="margin-top: 0.18rem;"
      >
        <div class="label">
          昨日问题
        </div>
        <div class="indicator-value">
          <div class="indicator-tags">
            <span
              v-if="!item.indicatorCodes || item.indicatorCodes.length === 0"
              class="no-indicator"
            >
              昨日门店服务表现很好，再接再厉呀！
            </span>
            <span
              v-for="indicatorCode in item.indicatorCodes"
              v-else
              :key="indicatorCode"
              class="indicator-item"
            >
              {{ INDICATOR_CUST_COMPLAINT_CODES_MAP[indicatorCode] }}
            </span>
          </div>
          <van-icon
            name="arrow"
            color="#999"
            style="margin-right: -0.1rem;"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContactBdApi from '@/api/contactBd';
import STATUS from '@/constants/status';
import tracker from '@/util/tracker';
import { BID } from '@/constants/statistics';
import { INDICATOR_CUST_COMPLAINT_CODES_MAP } from '@/constants/serviceLevel';

export default {
  name: 'PoiCard',
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      INDICATOR_CUST_COMPLAINT_CODES_MAP,
      cid: this.$CID.ServiceLevelPoiList,
    };
  },
  methods: {
    getServiceGradeImg(serviceGrade) {
      switch (serviceGrade) {
      case 1:
        return require('@/assets/img/service-level-img/1diamond-tag@3x.png');
      case 2:
        return require('@/assets/img/service-level-img/2diamond-tag@3x.png');
      case 3:
        return require('@/assets/img/service-level-img/3diamond-tag@3x.png');
      case 4:
        return require('@/assets/img/service-level-img/4diamond-tag@3x.png');
      case 5:
        return require('@/assets/img/service-level-img/5diamond-tag@3x.png');
      default:
        return '';
      }
    },
    goPoiDetail(poiId, poiName) {
      this.$router.push({
        name: 'ServiceLevelPoiDetail',
        query: {
          poiId,
          poiName,
          contactBdName: this.item.maintainerName,
          contactBdMis: this.item.maintainerMis,
        },
      });
      tracker.sendModuleClick(BID.SERVICE_LEVEL_POI_LIST_GO_POI_DETAIL, { poi_id: poiId }, { cid: this.cid });
    },
    async callPhone(poiId, misId) {
      tracker.sendModuleClick(BID.SERVICE_LEVEL_POI_LIST_CALL, { poi_id: poiId }, { cid: this.cid });
      this.$dialog.loading.show();
      try {
        const { status, data } = await ContactBdApi.getBDPhoneByPoiId(poiId, misId);
        if (status !== STATUS.SUCCESS || !data) return;
        window.location.href = `tel:${data}`;
      } catch (e) {
        console.error(e);
      } finally {
        this.$dialog.loading.hide();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.poi-card-item {
  background-color: #fff;
  border-radius: 0.24rem;
  padding: 0.24rem 0.23rem 0.24rem 0.24rem;
  margin-top: 0.24rem;
  width: 100%;
  font-family: "PingFang SC";
  .title {
    font-size: 0.32rem;
    font-weight: 600;
    line-height: 0.43rem;
    text-align: left;
  }
  .content {
    .content-item {
      display: flex;
      align-items: center;
      justify-self: start;
      font-size: 0.24rem;
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
      .label {
        color: #888;
        line-height: 0.42rem;
        height: 0.42rem;
        margin-right: 0.24rem;
        white-space: nowrap;
        flex-shrink: 0;
      }
      .service-level-value {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        flex: 1; /* 占据剩余空间 */
        row-gap: 0.12rem;
        img {
          height: 0.42rem;
          margin-right: 0.12rem;
        }
        .higher-rank {
          border-radius: 0.08rem;
          height: 0.42rem;
          line-height: 0.42rem;
          padding: 0 0.12rem;
          background-color: #FBF5E8;
          color: #986C24;
          font-size: 0.22rem;
          font-weight: 600;
        }
        .lower-rank {
          border-radius: 0.08rem;
          height: 0.42rem;
          line-height: 0.42rem;
          padding: 0 0.12rem;
          background-color: #F0F0F0;
          color: #666;
          font-size: 0.22rem;
        }
      }
      .maintainer-mis-value {
        line-height: 0.42rem;
        display: flex;
        flex: 1;
        align-items: center;
        justify-content: space-between;
        .phone-call {
          display: flex;
          align-items: center;
          img {
            height: 0.24rem;
            margin-right: 0.12rem;
          }
        }
      }
      .indicator-value {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-right: 0.14rem;
        .indicator-item {
          height: 0.42rem;
          line-height: 0.42rem;
          border-radius: 0.08rem;
          padding: 0 0.12rem;
          border: 2px solid #FF2727;
          color: #FF2727;
          font-size: 0.22rem;
          font-weight: 600;
          margin-right: 0.18rem;
        }
      }
    }
  }
}
</style>
